export default class CommonUtil {

  static isBoolean (obj) {
    return (typeof obj === 'boolean')
  }

  static isNumber (obj) {
    return (typeof obj === 'number')
  }

  static isString (obj) {
    return (typeof obj === 'string')
  }

  static isObject (obj) {
    return (typeof obj === 'object') && obj !== null
  }

  static isArray (obj) {
    return Array.isArray(obj)
  }

  static isFunction (obj) {
    return (typeof obj === 'function')
  }

  static isNull (obj, excludeUndefined = false) {
    return (obj == null) || (excludeUndefined === false && obj === 'undefined')
  }

  static isNotNull (obj, excludeUndefined = false) {
    return !(this.isNull(obj, excludeUndefined))
  }

  static isUndefined (obj) {
    return (typeof obj === 'undefined')
  }

  static isEmpty (obj, trim = false) {
    if (this.isNull(obj)) {
      return true
    }

    if (this.isString(obj)) {
      if (trim) {
        return (obj.trim().length <= 0)
      } else {
        return (obj.length <= 0)
      }
    }

    if (this.isArray(obj)) {
      return (obj.length <= 0)
    }

    if (this.isObject(obj)) {
      return (Object.keys(obj).length <= 0)
    }

    return false
  }

  static isNotEmpty (obj) {
    return !(this.isEmpty(obj))
  }

  static isSingleByteChar (chr) {
    // single byte char
    return ((chr >= 0x00 && chr < 0x81) || (chr === 0xf8f0) ||
      (chr >= 0xff61 && chr < 0xffa0) || (chr >= 0xf8f1 && chr < 0xf8f4))
  }

  static lengthBytes (text) {
    let resultBytes = 0

    for (let i = 0, len = text.length; i < len; i++) {
      const chr = text.charCodeAt(i)
      const chrBytes = this.isSingleByteChar(chr) ? 1 : 2
      resultBytes += chrBytes
    }

    return resultBytes
  }

  static substringBytes (text, length) {
    let resultBytes = 0
    let resultText = ''

    for (let i = 0, len = text.length; i < len; i++) {
      const chr = text.charCodeAt(i)
      const chrBytes = this.isSingleByteChar(chr) ? 1 : 2
      resultBytes += chrBytes

      if (resultBytes > length) {
        break
      }

      resultText = resultText + String.fromCharCode(chr)
    }

    return resultText
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js